import { styled } from 'mz-ui-kit'

export const Container = styled('div', {
  width: '100%',
  height: '31px',
  display: 'flex',
  flexFlow: 'row nowrap',
  alignItems: 'center',
})
